import { useEffect, useState } from "react";
import { rtctApi } from "services/rtctApi";

export function useFieldNodes() {
  const [devices, setDevices] = useState([]);
  const [mac, setMac] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      if (document.visibilityState === "visible") setRefresh((n) => n + 1);
    }, 30000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const abort = new AbortController();
    rtctApi
      .devices(abort.signal)
      .then((data) => {
        if (abort.signal.aborted) return;
        const rows = data.devices || [];
        setDevices(rows);
        setMac((current) => {
          let stored = "";
          try {
            stored = localStorage.getItem("field_node") || "";
          } catch {}
          return (
            [current, stored].find((candidate) =>
              rows.some((d) => d.mac === candidate),
            ) ||
            rows[0]?.mac ||
            ""
          );
        });
        setError("");
      })
      .catch((e) => {
        if (!abort.signal.aborted) setError(e.message);
      })
      .finally(() => {
        if (!abort.signal.aborted) setLoading(false);
      });
    return () => abort.abort();
  }, [refresh]);
  const select = (value) => {
    if (!devices.some((d) => d.mac === value)) return;
    setMac(value);
    try {
      localStorage.setItem("field_node", value);
    } catch {}
  };
  return {
    devices,
    mac,
    select,
    error,
    loading,
    refresh: () => setRefresh((n) => n + 1),
    node: devices.find((d) => d.mac === mac),
  };
}

export function useFieldResource(mac, loader, refresh = 0) {
  const [state, setState] = useState({
    data: null,
    error: "",
    loading: false,
    mac: "",
  });
  useEffect(() => {
    if (!mac) return;
    const abort = new AbortController();
    setState((old) => ({
      data: old.mac === mac ? old.data : null,
      error: "",
      loading: true,
      mac,
    }));
    loader(mac, abort.signal)
      .then((data) => {
        if (!abort.signal.aborted)
          setState({ data, error: "", loading: false, mac });
      })
      .catch((error) => {
        if (!abort.signal.aborted)
          setState({ data: null, error: error.message, loading: false, mac });
      });
    return () => abort.abort();
  }, [mac, loader, refresh]);
  return state.mac === mac ? state : { data: null, error: "", loading: !!mac };
}
